import { render, staticRenderFns } from "./RateCustomerList.vue?vue&type=template&id=3da31d96&scoped=true"
import script from "./RateCustomerList.vue?vue&type=script&lang=js"
export * from "./RateCustomerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da31d96",
  null
  
)

export default component.exports